var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"icon":"mdi-pencil","label":_vm.$t('integrations.btn.edit'),"hide-label":"","text":""},on:{"click":function($event){return _vm.goToActions(_vm.item)}}})}
var staticRenderFns = []

export { render, staticRenderFns }